import React, { Fragment } from 'react';
import PropTypes from "prop-types";

import {
    MessageField,
    SenderNameField,
    DeliveryDateField,
    RecipientNameField,
    RecipientEmailField
} from "../fields"

export const DigitalCardForm = ({ deliveryDateProps, isSelfBuy }) => {

    if(!isSelfBuy) {
        return (
            <Fragment>
                <SenderNameField />
                <RecipientNameField />
                <RecipientEmailField />
                <MessageField />
                <DeliveryDateField {...deliveryDateProps} />
            </Fragment>
        );
    }
    return (<Fragment />);
};

DigitalCardForm.propTypes = {
    deliveryDateProps: PropTypes.object.isRequired,
    isSelfBuy: PropTypes.bool.isRequired
};
